import React from "react";

const PrivacyPolicy = () => {
  return (
    <main style={{ textAlign: 'left' }}>
      <section style={{ paddingBottom: '1.5rem', background: 'linear-gradient(to bottom, white, #FFF7ED)', backgroundColor: 'white', lineHeight: '1.75rem' }}>
        <div style={{ margin: '0 auto', paddingLeft: '1rem', paddingRight: '1rem', maxWidth: '944px' }}>
          <h1 style={{ textAlign: 'center', fontSize: '1.875rem', fontWeight: 'bold', marginBottom: '0.25rem', marginTop: '0.25rem' }}>PRIVACY POLICY</h1>
          <h3 style={{textAlign: 'center', fontSize: '1.125rem', marginBottom: '3.25rem' }}>Updated On: 3/10/25</h3>
          <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '0.25rem' }}>INTRODUCTION</h2>
          <p style={{ marginBottom: '0.5rem' }}>
            This privacy policy describes how Phoenix Relational, LLC,
            &nbsp;d/b/a Trusted Therapist Network (“Trusted Therapist Network,” “we,” “us,” or “our”)
            collects, uses, shares, and otherwise handles personal information
            about individuals (“you” and/or “your”) who visit and use any of our
            websites or mobile applications that include a link to this privacy
            policy, and any related products, features, and services
            (collectively, the “Services”).
          </p>
          <p style={{ marginBottom: '0.5rem' }}>
            By using the Services you acknowledge that you have read this
            privacy policy, and consent to the handling of your personal
            information as described in this privacy policy, which we may update
            from time to time as described in the&nbsp;
            <a
              style={{ color: '#93C5FD' }}
              href="https://www.doximity.com/clinicians/privacy#pp9"
            >
              “Changes to this Policy”
            </a>{" "}
            &nbsp;section, below.
          </p>
          <p style={{ marginBottom: '0.5rem' }}>
            Trusted Therapist Network is a United States company. The Trusted Therapist Network Services
            are not intended for users outside of the United States and non-US
            mental health practitioners and scholars are not eligible for Word
            of Mouth membership. By using the Services, you consent to your
            personal information being stored and otherwise processed in the
            United States as described in this privacy policy.
          </p>
          <ol style={{ listStyleType: 'decimal', marginLeft: '2rem', marginBottom: '0.5rem' }} start={1}>
            <li style={{ fontWeight: 'bold' }}>COLLECTION OF INFORMATION</li>
          </ol>
          <p style={{ marginBottom: '0.5rem' }}>
            We collect personal information that you provide us directly, from
            third-party sources, and automatically when you use the Services as
            follows:
          </p>
          <p style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>
            Information That You Provide To Us Directly
          </p>
          <p style={{ fontStyle: 'italic', marginBottom: '0.5rem' }}>Trusted Therapist Network Member Accounts</p>
          <p style={{ marginBottom: '0.5rem' }}>
            When you register a Trusted Therapist Network account and become a Trusted Therapist Network
            member, we require you to provide certain personal information that
            varies depending on whether we have already created a professional
            profile for you, as described in the&nbsp;
            <a
              style={{ color: '#93C5FD' }}
              href="https://www.doximity.com/clinicians/privacy#pp2s2"
            >
              “Trusted Therapist Network Profiles and Member Accounts”
            </a>
            &nbsp;section below. If you already have a profile, we ask that you
            verify the information, and if you do not we ask that you provide us
            some of the information typically included in a Trusted Therapist Network
            profile. All Trusted Therapist Network members must provide their e-mail
            address, and all mental health practitioners are required to provide
            certain information about their education, such as school attended,
            year of graduation, and specialty.
          </p>
          <p style={{ marginBottom: '0.5rem' }}>
            Registering Trusted Therapist Network members also have the option to provide
            additional information to include in their profile, including
            clinical and professional interests, languages spoken at the office,
            profile photo, clinical or professional group or affiliations,
            internship, employment history, speaking engagements, publications,
            memberships and board certifications. You may choose to update or
            supplement the information you have provided us at any time as
            described in the&nbsp;
            <a
              style={{ color: '#93C5FD' }}
              href="https://www.doximity.com/clinicians/privacy#pp8"
            >
              “Updating Your Account Information”
            </a>
            &nbsp;section below.
          </p>
          <p style={{ marginBottom: '0.5rem' }}>
            To enhance the accuracy and integrity of the Trusted Therapist Network mental
            health practitioner directory, we require registering members to
            verify their identity and credentials, which verification may
            require them to answer identity verification questions and/or
            provide us a professional e-mail address, a copy of their
            professional license, medical ID (if applicable) or other relevant
            documentation. While we take steps to verify that Trusted Therapist Network
            members are actually the mental health practitioners they claim to
            be,{" "}
            <span style={{ textDecoration: 'underline' }}>
              we make no guarantee as to any member’s identity, professional
              credentials or licensure status.
            </span>
          </p>
          <p style={{ fontStyle: 'italic', marginBottom: '0.5rem' }}>Submissions</p>
          <p style={{ marginBottom: '0.5rem' }}>
            We collect content and information that you submit to the Services
            (and information about you may be provided by other Trusted Therapist Network
            members), including comments, searches, contacts, schedule details,
            your resume, survey responses, contest entries, creative
            submissions, and member support requests.
          </p>
          <p style={{ fontStyle: 'italic', marginBottom: '0.5rem' }}>Communications Tools</p>
          <p style={{ marginBottom: '0.5rem' }}>
            The Services include secure communication tools that enable our
            members to communicate with each other. We collect information about
            usage of these tools, such as when a member uses the tool. We do not
            monitor communication content.
          </p>
          <p style={{ marginBottom: '0.5rem', fontWeight: 'bold' }}>
            Information Collected Automatically When You Use the Services
          </p>
          <p style={{ marginBottom: '0.5rem' }}>
            In addition to your personal information that you provide to us
            directly, we collect a variety of personal information automatically
            when you use the Services through the use of cookies and similar
            technologies (e.g., pixels, web beacons and device identifiers),
            which we refer to as “Log Data” as further described in the&nbsp;
            <a
              style={{ color: '#93C5FD' }}
              href="https://www.doximity.com/clinicians/privacy#pp4"
            >
              “Cookies and Similar Technologies“
            </a>
            &nbsp;section below. Log Data includes activity information such as
            the date and time that you access one of our sites or apps, and
            whether you view, click or otherwise interact with content,
            including articles, links, advertisements promoting the products and
            services of Trusted Therapist Network or our customers, open or click a link in
            one of our e-mails, conduct a search on one of our websites, share
            an article displayed in your newsfeed, or send, receive, or engage
            with a message sent through the Services. We collect device
            information including your IP address (which is a unique numerical
            address that identifies your device when you access the Internet),
            your browser and device type and model, operating system, your ISP
            and mobile carrier, your advertising ID (which is a unique,
            user-resettable identification number associated with a mobile
            device), other unique identifiers associated with your computer or
            mobile device, and the URL of the site from which you access our
            site.
          </p>
          <p style={{ marginBottom: '0.5rem' }}>
            The use of these technologies helps us serve you better by
            understanding what you are interested in, tracking trends, measuring
            the effectiveness of our content, which may include ads, and saving
            your preferences. For information about how you can manage your
            cookie preferences, refer to the&nbsp;
            <a
              style={{ color: '#93C5FD' }}
              href="https://www.doximity.com/clinicians/privacy#pp8"
            >
              “Choices Regarding Personal Information”
            </a>
            &nbsp;section, below.
          </p>
          <p style={{ marginBottom: '0.5rem' }}>
            We do not collect precise location information unless you elect to
            enable location services on your device, but we do receive
            information about your general location at a city or zip code level
            through your computer’s IP address and your mobile device.
          </p>
          <p style={{ fontWeight: 'bold' }}>
            Information Obtained From Third-party Sources
          </p>
          <p style={{ marginBottom: '0.5rem' }}>
            We collect information from third-party sources, including
            government agencies, publicly available databases, professional
            associations, publications, employers, our business partners,
            service providers, customers, and other Trusted Therapist Network members, some
            of which we may add to your professional profile as described in the&nbsp;
            <a
              style={{ color: '#93C5FD' }}
              href="https://www.doximity.com/clinicians/privacy#pp2s2"
            >
              “Trusted Therapist Network Profiles and Member Accounts”
            </a>
            &nbsp;section, below. For example, we may use third-party sources to
            obtain your National Provider Identifier (NPI) record, specialty,
            office address, phone and fax numbers, educational background,
            certifications, professional group affiliations, your publications
            and other professional achievements. We also may obtain e-mail
            addresses that we use to promote the Services to members and
            potential members, and other data that we may use to personalize
            content, including advertising.
          </p>
          <ol style={{ listStyleType: 'decimal', marginLeft: '2rem', marginBottom: '0.5rem' }} start={2}>
            <li style={{ fontWeight: 'bold' }}>&nbsp;USES OF INFORMATION</li>
          </ol>
          <p style={{ marginBottom: '0.5rem' }}>
            Except as otherwise provided herein, we may use the personal
            information we collect about you for the following business and
            commercial purposes:
          </p>
          <p style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>Provision of the Services</p>
          <p style={{ marginBottom: '0.5rem' }}>
            We use your information to provide, operate, support, and improve
            the Services, including through the development of new tools and
            features.
          </p>
          <p style={{ fontWeight: 'bold' }}>
            Trusted Therapist Network Profiles and Member Accounts
          </p>
          <p style={{ marginBottom: '0.5rem' }}>
            We use your information to create and update your professional
            profile, which is generally viewable within the Services by default,
            regardless of whether you have registered a Trusted Therapist Network account,
            to create and maintain your Trusted Therapist Network member account if you
            choose to register, and to support and respond to your inquiries and
            requests.
          </p>
          <p style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>Communications</p>
          <p style={{ marginBottom: '0.5rem' }}>
            We use your information to communicate with you about the Services.
            These communications may contain information about your professional
            connections, professional opportunities, conferences and other
            events, relevant editorial content, and marketing about products and
            services of Trusted Therapist Network and our customers. These communications
            may be sent through a variety of channels, including on-site or
            in-app notifications and e-mail. We also use your information to
            process, store, and transmit your communications through the
            Services.
          </p>
          <p style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>Professional Connections</p>
          <p style={{ marginBottom: '0.5rem' }}>
            We use your information to suggest potential connections to you and
            other Trusted Therapist Network members. For example, if we see that you and
            another member share a contact or attended the same university, we
            may suggest that you and that member connect as colleagues. We use
            your information to enhance our Trusted Therapist Network search feature to help
            you find information and learn more about other Trusted Therapist Network
            members, and for other Trusted Therapist Network members to find you. For
            example, you can search for mental health practitioners with
            particular expertise, or that you may know from your university or
            past employment. We may also use your information, including your
            name and photo, to notify other Trusted Therapist Network members of notable
            professional events, such as when you receive an award, are
            mentioned in the news or publish a work. We may also inform your
            connections when you like, share or comment on a newsfeed article,
            make a new Trusted Therapist Network connection or update your profile.
          </p>
          <p style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>Personalizing your Experience</p>
          <p style={{ marginBottom: '0.5rem' }}>
            We use your information to personalize the Services including
            content and marketing messages served to you on our sites and
            third-party sites, and to generally enhance your Trusted Therapist Network
            experience. For example, we may tailor your announcements to focus
            on content relevant to your practice, specialty and inferred
            interests based on your profile and how you engage with the
            Services. In the future we may use your information to target (and
            measure the performance of) advertising and other content sponsored
            by third parties, including (for example) promoting relevant
            potential career opportunities to you. Advertising will be
            identified as an “Advertisement,” “Sponsored,” “Promoted” or some
            similar designation indicating that the content is promotional and
            has been selected by the third-party sponsor.
          </p>
          <p style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>Other Uses of Your Information</p>
          <p style={{ marginBottom: '0.5rem' }}>
            We also use your information to detect, investigate, and prevent
            fraudulent, harmful, unauthorized, unethical or illegal activities
            to protect the rights, safety and property of Trusted Therapist Network, our
            members and others, including through the enforcement of our{" "}
            <a
              style={{ color: '#93C5FD' }}
              href={`${window.location.origin}/public/terms`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms of Service
            </a>
            , in connection with legal proceedings, including arbitration, and
            to comply with our legal obligations. Also, we may create anonymous,
            aggregated or de-identified data from your personal information and
            other individuals whose personal information we collect. We may use
            this anonymous, aggregated or de-identified data and share it with
            third parties for our lawful business purposes, including to analyze
            and improve the Services and promote our business.
          </p>
          <ol style={{ listStyleType: 'decimal', marginLeft: '2rem', marginBottom: '0.5rem' }} start={3}>
            <li style={{ fontWeight: 'bold' }}>SHARING OF INFORMATION</li>
          </ol>
          <p style={{ marginBottom: '0.5rem' }}>
            In connection with the activities described above, we may share your
            personal information with third parties as follows:
          </p>
          <p style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>Social Networks</p>
          <p style={{ marginBottom: '0.5rem' }}>
            As described in the{" "}
            <a
              href="https://www.doximity.com/clinicians/privacy#pp2s2"
            >
              “Trusted Therapist Network Profiles and Member Accounts”
            </a>
            &nbsp;section above, we create your professional profile within the
            Services, which is generally viewable within the Services by other
            members of the Services by default. No information is provided to
            potential clients/patients except general office information
            including, but not necessarily limited to, street address, email,
            phone numbers, office hours and website addresses. Note that any
            personal information you elect to share within Trusted Therapist Network’s
            social network is visible to Trusted Therapist Network’s members. For example,
            if you engage in social actions, e.g., by liking or commenting on an
            announcement or blog, those activities will be shared with other
            Trusted Therapist Network members. Also, we may include social widgets on our
            sites and apps that enable you to interact with the associated
            social media services, e.g., to share an article, and in connection
            with such interaction these third parties may collect personal
            information about you. You may be able to manage your privacy
            preferences directly with the applicable social network platform.
          </p>
          <p style={{ marginBottom: '0.5rem', fontWeight: 'bold' }}>Business Partners</p>
          <p style={{ marginBottom: '0.5rem' }}>
            We may share your profile information with trusted business partners
            that we work with to provide services to you and others, including
            mental health practitioner directories and ranking bodies. These
            services increase the visibility of our members and their employers
            in the mental health market, thereby increasing their business and
            professional opportunities.
          </p>
          <p style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>Service Providers</p>
          <p style={{ marginBottom: '0.5rem' }}>
            We may share your information with third parties that help us
            provide the Services and operate our business, including in the
            areas of website and database hosting and maintenance,
            telecommunications, information security, fraud detection and
            prevention, e-mail management, data analytics, marketing,
            advertising, member support, and identity and professional
            credential verification.
          </p>
          <p style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>Advertising Partners</p>
          <p style={{ marginBottom: '0.5rem' }}>
            We may work with third-party partners to serve advertising for us on
            third-party sites and to evaluate the effectiveness of our
            advertising. These third parties use cookies and similar
            technologies to collect information about your use of our sites,
            other sites and online services over time, including certain Log
            Data described above, so they can display our ads to you on other
            sites and apps. For example, if you visit Trusted Therapist Network and also use
            a social media platform, you may see a Trusted Therapist Network ad in your
            social media newsfeed. We also work with third-party partners to
            develop custom audiences to whom our ads can be delivered outside of
            Trusted Therapist Network. For example, we may provide hashed versions of member
            e-mail addresses to Facebook who then matches it to the
            corresponding Facebook member accounts to create a Trusted Therapist Network
            “Custom Audience” on Facebook, to which it can target Trusted Therapist Network
            ads. These activities, known as interest-based advertising, are
            intended to make the ads you see online more relevant to your
            interests. Please see the{" "}
            <a
              href="https://www.google.com/url?q=https://www.doximity.com/clinicians/privacy%23pp8&sa=D&source=editors&ust=1684168459656050&usg=AOvVaw0djkyhz3Hx0tAA8c_rcmg_"
            >
              “Choices Regarding Personal Information”
            </a>
            &nbsp;section below for information about opting out of
            interest-based based advertising.
          </p>
          <p style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>Business Transferees</p>
          <p style={{ marginBottom: '0.5rem' }}>
            We may share your personal information in connection with a business
            transaction (or potential transaction) involving a corporate
            divestiture, merger, consolidation, acquisition, reorganization,
            sale or other disposition of all or any portion of the business or
            assets of, or equity interests in, Trusted Therapist Network or our corporate
            affiliates (including, in connection with a bankruptcy or similar
            proceedings).
          </p>
          <p style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>Affiliated Companies</p>
          <p style={{ marginBottom: '0.5rem' }}>
            We may share personal information with our corporate affiliates for
            use consistent with this privacy policy.
          </p>
          <p style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>Authorities</p>
          <p style={{ marginBottom: '0.5rem' }}>
            We may access, preserve, and share your information with third
            parties, as required or permitted by applicable law, if we believe
            it is reasonably necessary to comply with legal process and law
            enforcement instructions and orders, such as a search warrant,
            subpoena, statute, judicial proceeding, or other legal process
            served on us, which may involve disclosure to law enforcement,
            courts, or governmental authorities.
          </p>
          <p style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>Other Third Parties</p>
          <p style={{ marginBottom: '0.5rem' }}>
            We may access, preserve, and share your information if we determine
            it is reasonably necessary or appropriate to investigate, prevent or
            take action regarding suspected fraudulent, harmful, unethical or
            illegal activities, or any violation of our{" "}
            <a
              style={{ color: '#93C5FD' }}
              href={`${window.location.origin}/public/terms`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms of Service
            </a>
            &nbsp;or to protect and defend the legal rights, safety, and
            property of Trusted Therapist Network, our employees, agents and contractors
            (including to enforce our agreements) or in connection with any
            safety or security concerns, including the personal safety of our
            members and the public.
          </p>
          <p style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>With Your Consent</p>
          <p style={{ marginBottom: '0.5rem' }}>
            We also may share your personal information with a third party in a
            manner not addressed by this privacy policy with your consent.
          </p>
          <ol style={{ listStyleType: 'decimal', marginLeft: '2rem', marginBottom: '0.5rem' }} start={4}>
            <li style={{ fontWeight: 'bold' }}>
              &nbsp;COOKIES AND SIMILAR TECHNOLOGIES
            </li>
          </ol>
          <p style={{ marginBottom: '0.5rem' }}>
            We and our service providers and partners, as described above, use
            various tools to collect data when you visit our sites and apps,
            including cookies, pixel tags, and other similar technologies. These
            technologies enable us to track usage of the Services and to enhance
            the user experience by providing a more relevant and personalized
            online experience. A cookie is a small data file that is sent to a
            user’s browser when visiting a website. It is stored, accessed and
            maintained on the computer’s hard drive or on a tablet or mobile
            device. A cookie contains a unique number that allows a website to
            recognize a particular user’s device each time that user visits the
            website so they don’t need to log in each time they visit and their
            preferences can be stored. Cookies enable us to measure the use and
            effectiveness of our content, track user trends, monitor and
            stabilize our websites, and improve the quality of the Services and
            content personalization (including ads) both on Trusted Therapist Network and
            third-party sites.
          </p>
          <p style={{ marginBottom: '0.5rem' }}>
            Most browsers can be set to reject all cookies, including
            third-party cookies, however, if you choose to reject our cookies,
            your ability to access and use the Services will be limited. We and
            our partners also use pixel tags, often in conjunction with cookies.
            Pixel tags are small pieces of code that are embedded on web pages
            and apps in order to provide us with information about how our sites
            and apps are used. We also include pixel tags in our e-mails to
            inform us whether the recipient has opened those e-mails and/or
            clicked on links in those e-mails.
          </p>
          <ol style={{ listStyleType: 'decimal', marginLeft: '2rem', marginBottom: '0.5rem' }} start={5}>
            <li style={{ fontWeight: 'bold' }}>THIRD-PARTY LINKS</li>
          </ol>
          <p>
            Our Services may contain links to third-party sites. Any access to
            and use of such linked sites is not governed by this privacy policy,
            but instead is governed by the privacy policies of those third-party
            sites, which we encourage you to read. We are not responsible for
            the information practices of such third-party sites.
          </p>
          <ol style={{ listStyleType: 'decimal', marginLeft: '2rem', marginBottom: '0.5rem' }} start={6}>
            <li style={{ fontWeight: 'bold' }}>SECURITY</li>
          </ol>
          <p style={{ marginBottom: '0.5rem' }}>
            We employ technical, administrative and physical safeguards designed
            to protect your personal information. However, no security measure
            can guarantee security and that data will not be accessed,
            disclosed, altered, or destroyed. You should take steps to protect
            against unauthorized access to your password, phone, and computer
            by, among other things, signing off after using a shared computer,
            choosing a complex password that nobody else knows or can easily
            guess, and keeping your log-in credentials private. We are not
            responsible for any lost, stolen, or compromised passwords or for
            any unauthorized account activity.
          </p>
          <ol style={{ listStyleType: 'decimal', marginLeft: '2rem', marginBottom: '0.5rem' }} start={7}>
            <li style={{ fontWeight: 'bold' }}>&nbsp;DATA RETENTION</li>
          </ol>
          <p style={{ marginBottom: '0.5rem' }}>
            We will retain your personal information for at least the period
            reasonably necessary to fulfill the purposes outlined in this
            privacy policy, unless a longer retention period is required or
            permitted by law. If we delete some or all of your personal
            information, we may continue to retain and use aggregate or
            anonymous data previously collected and/or aggregate or anonymize
            your personal information.
          </p>
          <ol style={{ listStyleType: 'decimal', marginLeft: '2rem', marginBottom: '0.5rem' }} start={8}>
            <li style={{ fontWeight: 'bold' }}>
              CHOICES REGARDING PERSONAL INFORMATION
            </li>
          </ol>
          <p style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>
            Your Account and Profile Information.
          </p>
          <p style={{ marginBottom: '0.5rem' }}>
            If you have registered a Trusted Therapist Network account, you may review and
            update certain personal information through your account settings.
            If you prefer to submit an update request to us directly, or if you
            wish to close your account, please contact us at{" "}
            <a
              style={{ color: '#93C5FD' }}
              href="mailto:team@thettn.com"
            >
              team@thettn.com.
            </a>
          </p>
          <p style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>Opting Out of Marketing E-mails</p>
          <p style={{ marginBottom: '0.5rem' }}>
            You may opt-out of receiving marketing e-mails from Trusted Therapist Network at
            any time by opting out via the link in the e-mail footer, adjusting
            your account settings or sending an opt-out request to{" "}
            <a
              href="mailto:team@thettn.com"
              style={{ color: '#93C5FD' }}
            >
              team@thettn.com
            </a>
            . Please be aware that you cannot opt-out of receiving services
            messages from us including security and legal notices.
          </p>
          <p style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>
            Controlling Cookies and Interest-based Advertising
          </p>
          <p style={{ marginBottom: '0.5rem' }}>
            If you would prefer not to accept cookies, visit the “help” section
            of your browser to learn about cookie preferences and other privacy
            settings that may be available. Most browsers will allow you to: (i)
            change your browser settings to notify you when you receive a
            cookie, which lets you choose whether or not to accept it; (ii)
            disable existing cookies; or (iii) set your browser to automatically
            reject cookies. Note that rejecting cookies will not prevent device
            identification and related data collection from occurring. Also, if
            you choose to reject cookies, your access to some functionality and
            areas of the Services may be restricted. For additional information
            about cookies visit{" "}
            <a
              style={{ color: '#93C5FD' }}
              href="https://www.allaboutcookies.org/"
            >
              www.allaboutcookies.org
            </a>
            .
          </p>
          <p style={{ marginBottom: '0.5rem' }}>
            As described above, we allow certain third-party partners to place
            tracking technologies on the Services for the purpose of delivering
            interest-based advertising to you on third-party sites. You can
            opt-out of certain third-party interest-based advertising services
            we may use by visiting the following links: for Google:{" "}
            <a
              style={{ color: '#93C5FD' }}
              href="https://adssettings.google.com/authenticated?hl=en#display_optout"
            >
              Google Marketing Platform opt-out page
            </a>
            ; For Twitter:{" "}
            <a
              href="https://help.twitter.com/en/safety-and-security/privacy-controls-for-tailored-ads"
            >
              Twitter’s Privacy Controls for Personalized Ads
            </a>
            ; For Facebook:{" "}
            <a
              style={{ color: '#93C5FD' }}
              href="https://www.facebook.com/ads/preferences/?entry_product=ad_settings_screen"
            >
              Facebook Ad Preferences
            </a>
            ; and for LinkedIn:{" "}
            <a
              style={{ color: '#93C5FD' }}
              href="https://www.linkedin.com/psettings/advertising"
            >
              LinkedIn General Advertising Preferences{""}
            </a>
            .
          </p>
          <p style={{ marginBottom: '0.5rem' }}>
            You can learn more about managing your preferences for
            interest-based ads online, particularly for many third-party
            advertising networks, by visiting the{" "}
            <a
              style={{ color: '#93C5FD' }}
              href="https://optout.networkadvertising.org/?c=1"
            >
              Network Advertising Initiative
            </a>
            &nbsp;and the{" "}
            <a
              style={{ color: '#93C5FD' }}
              href="https://optout.aboutads.info/?c=2&lang=EN"
            >
              Digital Advertising Alliance
            </a>
            . Note that even if you opt-out from interest-based advertising
            through these organizations’ tools, cookies may still be used to
            collect data for purposes other than interest-based advertising,
            including analytics. Also, you will still see ads, but they will not
            be targeted based upon the information collected through these
            tracking technologies. When using the preferences and opt-out
            settings described above, you will need to apply them on every
            device and on every browser from which you wish to opt-out. Because
            some of these settings rely on a cookie that stores your
            preferences, if you delete or clear your browser’s cookies, you may
            need to opt-out again. You can also control interest-based
            advertising on your mobile device by enabling the “Limit Ad
            Tracking” setting on your iOS device or “Opt out of Ads
            Personalization” on your Android devices.
          </p>
          <p style={{ marginBottom: '0.5rem' }}>
            Some Web browsers incorporate a “Do Not Track” feature that signals
            to websites that you visit that you do not want to have your online
            activity tracked. Each browser communicates “Do Not Track” signals
            to websites differently, making it unworkable to honor each and
            every request correctly. We do not respond to “Do Not Track” signals
            at this time.
          </p>
          <p style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>Google Analytics</p>
          <p style={{ marginBottom: '0.5rem' }}>
            We use Google Analytics to track and analyze certain traffic and
            usage statistics regarding the use of our Services, such as the
            number of visitors to our Services, how visitors are navigating to
            our Services, visitors’ general geographic region information, how
            long individuals are visiting our Services, and information about
            the equipment individuals are using to access our Services (e.g.,
            browser version and operating system). &nbsp;Google Analytics may
            use a Google Analytics cookie and may collect your IP address or
            mobile device ID as part of this service (but neither we nor Google
            Analytics otherwise collects or processes any of your personal
            information in connection with our use of the Google Analytics
            services). &nbsp;We use this traffic and usage information to gauge,
            internally, the effectiveness of our advertising efforts and to make
            improvements to our Website and our marketing and promotional
            efforts.
          </p>
          <p style={{ marginBottom: '0.5rem' }}>
            In addition, we may use the following Google Analytics Advertising
            Features:
          </p>
          <ul style={{ listStyleType: "disc", marginLeft: "2rem", marginBottom: "0.5rem" }}>
            <li style={{ marginBottom: '0.5rem' }}>Remarketing</li>
            <li style={{ marginBottom: '0.5rem' }}>
              Google Display Network Impression Reporting
            </li>
            <li style={{ marginBottom: '0.5rem' }}>
              Google Analytics Demographics and Interest Reporting
            </li>
            <li style={{ marginBottom: '0.5rem' }}>
              Google Ads (an integrated service with Google Analytics)
            </li>
          </ul>
          <p style={{ marginBottom: '0.5rem' }}>
            By enabling these features, we would be permitting Google to collect
            certain additional traffic and usage data using a Google Advertising
            cookie and other identifiers not tied to your personal information.
            &nbsp;This information includes demographic information about our
            Services and general information about our visitors’ interests, but
            does not identify our visitors individually. &nbsp;In fact, we are
            prohibited by Google policy from using this information to try to
            identify individual users and from merging non-personally
            identifiable information obtained from Google with personal
            information we otherwise have about you without obtaining your
            separate consent. &nbsp;We use the information collected through our
            use of the Google Analytics Advertising Features to segment our
            audience and to better target our advertising and marketing efforts.
            &nbsp;For more information, please review the following:
          </p>
          <ul style={{ listStyleType: "disc", marginLeft: "2rem", marginBottom: "0.5rem" }}>
            <li style={{ marginBottom: '0.5rem' }}>
              Information about Google’s use of cookies:{" "}
              <a
                style={{ color: '#93C5FD' }}
                href="https://www.policies.google.com/technologies/types"
              >
                www.policies.google.com/technologies/types
              </a>
            </li>
            <li style={{ marginBottom: '0.5rem' }}>
              Information about Google’s use of information from sites or apps
              that use Google’s services:{" "}
              <a
                style={{ color: '#93C5FD' }}
                href="https://policies.google.com/technologies/partner-sites"
              >
                www.policies.google.com/technologies/partner-sites
              </a>
            </li>
          </ul>
          <p style={{ marginBottom: '0.5rem' }}>
            You can opt out of our use of certain Google Analytics features by
            updating the “Ads Settings” in your browser (
            <a
              style={{ color: '#93C5FD' }}
              href="https://adssettings.google.com/authenticated"
            >
              www.adssettings.google.com/authenticated
            </a>
            ) or mobile device (
            <a
              href="https://support.google.com/ads/answer/1660762#mob"
            >
              www.support.google.com/ads/answer/1660762#mob
            </a>
            ), by visiting the Network Advertising Initiative’s Consumer Opt-Out
            page at {" "}
            <a
              style={{ color: '#93C5FD' }}
              href="https://optout.networkadvertising.org/"
            >
              www.optout.networkadvertising.org/
            </a>
            , or by visiting Google’s currently available opt-outs over the web
            at{" "}
            <a
              style={{ color: '#93C5FD' }}
              href="https://tools.google.com/dlpage/gaoptout/"
            >
              www.tools.google.com/dlpage/gaoptout/
            </a>
            .
          </p>
          <p style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>Push Notifications</p>
          <p style={{ marginBottom: '0.5rem' }}>
            If you consent to receive push notifications, you may withdraw your
            consent at any time by adjusting the appropriate operating system
            settings on your mobile device.
          </p>
          <ol style={{ fontWeight: "bold", listStyleType: "decimal", marginLeft: "2rem", marginBottom: "0.5rem" }} start={9}>
            <li style={{ marginBottom: '0.5rem' }}>&nbsp;CHANGES TO THIS PRIVACY POLICY</li>
          </ol>
          <p style={{ marginBottom: '0.5rem' }}>
            We reserve the right to modify this privacy policy at any time and
            in our sole discretion. When we make a change, we will update the
            “Effective Date” and post the updated policy on or through the
            Services. We may, and if required by law will, also provide
            notification of changes in another way that we believe is reasonably
            likely to reach you, such as by e-mail (if you have an account where
            we have your contact information) or another manner through the
            Services. Any modifications to this privacy policy will be effective
            upon posting or as otherwise indicated at the time of posting. In
            all cases, by continuing to use the Services after posting of the
            updated policy, you are consenting to the changes. If you object to
            any changes, you may close your account by contacting{" "}
            <a href="mailto:team@thettn.com">
              team@thettn.com
            </a>
            .
          </p>
          <ol style={{ fontWeight: "bold", listStyleType: "decimal", marginLeft: "2rem", marginBottom: "0.5rem" }} start={10}>
            <li style={{ marginBottom: '0.5rem' }}>CALIFORNIA PRIVACY NOTICE</li>
          </ol>
          <p style={{ marginBottom: '0.5rem' }}>
            California law provides its residents with additional rights
            regarding their personal information. To learn more about California
            privacy rights, please visit our{" "}
            <a
              href="https://www-new.belongly.com/california-privacy-policy/"
            >
              California Privacy Notice
            </a>
          </p>
          <ol style={{ fontWeight: "bold", listStyleType: "decimal", marginLeft: "2rem", marginBottom: "0.5rem" }} start={11}>
            <li style={{ marginBottom: '0.5rem' }}>CONTACT US</li>
          </ol>
          <p>
            If you have any questions about this privacy policy or Word of
            Mouth’s privacy practices, you may reach us at any time by e-mailing{" "}
            <a href="mailto:team@thettn.com">
              team@thettn.com
            </a>
            &nbsp;or by contacting us via mail at: Trusted Therapist Network, 22311 South
            Woodland Road, Shaker Heights, OH, 44122.
          </p>
        </div>
      </section>
    </main>
  );
};

export default PrivacyPolicy;
